import { CaseEventDTOWithUserDetails } from 'api/model';
import { ColumnSetting } from 'components/Table/utils';
import useUsers from 'contexts/basicData/useUsers';
import { formatDateTime } from 'utils/date-helpers';
import { makeDateComparator, makeStringComparator } from 'utils/sorting';
import { useMemo } from 'react';
import useTranslations from 'contexts/basicData/useTranslations';

const useBaseCaseEventWidgetColumnSettings = () => {
  const { assignmentTypes, assignmentStatuses, caseTypes } = useTranslations();
  const users = useUsers();
  const result = useMemo(() => {
    const columns: ColumnSetting<CaseEventDTOWithUserDetails, any>[] = [
      {
        head: 'Nr',
        render: (e, t, f, i) => i + 1,
        width: 15,
      },
      {
        head: 'Reg.nr',
        render: (row) => `${row.registrationNumber}`,
        width: 50,
        sortFunction: makeStringComparator((row) => row.registrationNumber),
      },
      {
        head: 'Ärendetyp',
        render: (row) => <span>{caseTypes[row.caseType]}</span>,
        width: 100,
        sortFunction: makeStringComparator(
          (row) => caseTypes[row.caseType] ?? ''
        ),
      },
      {
        head: 'Uppdragstyp',
        render: (row) => (
          <span>{assignmentTypes[row.assignmentType!] ?? ''}</span>
        ),
        width: 100,
        sortFunction: makeStringComparator(
          (row) => assignmentTypes[row.assignmentType!] ?? ''
        ),
      },
      {
        head: 'Status',
        render: (row) => (
          <span>{assignmentStatuses[row.assignmentStatus] ?? ''}</span>
        ),
        width: 100,
        sortFunction: makeStringComparator(
          (row) => assignmentStatuses[row.assignmentStatus] ?? ''
        ),
      },
      {
        head: 'Est. tid satt av',
        render: (row) => {
          return (
            <span>
              {row.modifiedEstimatedDurationByID &&
              users[row.modifiedEstimatedDurationByID]
                ? users[row.modifiedEstimatedDurationByID].name
                : '-'}
            </span>
          );
        },
        width: 100,
        sortFunction: (a, b) =>
          (
            users[a.modifiedEstimatedDurationByID ?? '']?.name ?? ''
          ).localeCompare(
            users[b.modifiedEstimatedDurationByID ?? '']?.name ?? ''
          ),
      },
      {
        head: 'Fälttestare',
        render: (row) => {
          return <span>{row.assignedToUserName ?? ''}</span>;
        },
        width: 100,
        sortFunction: makeStringComparator(
          (row) => row.assignedToUserName ?? ''
        ),
      },
      {
        head: 'Telefonnummer',
        render: (row) => {
          return <span>{row.assignedToUserPhoneNumber ?? ''}</span>;
        },
        width: 100,
        sortFunction: makeStringComparator(
          (row) => row.assignedToUserPhoneNumber ?? ''
        ),
      },
      {
        head: 'Justerat vid',
        render: (row) => `${formatDateTime(row.created)}`,
        width: 100,
        sortFunction: makeDateComparator((row) => row.created),
      },
    ];
    return columns;
  }, [assignmentStatuses, assignmentTypes, caseTypes, users]);

  return result;
};

export default useBaseCaseEventWidgetColumnSettings;
